<template>
    <div>
        <div class='login-container'>
            <div class='input-area'>
                <input v-model='username'
                       placeholder='아이디 (이메일)'
                       type='text'
                       @keyup.enter='signup' />
                <input v-model='password'
                       placeholder='비밀번호'
                       type='password'
                       @keyup.enter='signup' />
            </div>
            <div class='com-check'>
                <input id='check-all' v-model='isSaveId' name='check-all' type='checkbox'>
                <label for='check-all'>아이디 저장</label>
            </div>
            <div class='btn-area'>
                <button @click='signup'>로그인</button>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    name: 'adminLogin',
    props: {},
    data() {
        return {
            cid: 0,
            username: '', // root
            password: '', // root
            errorMessage: '',
            isSaveId: false,
        };
    },
    mounted() {
        // 화면 진입시 로그아웃 처리
        this.$store.dispatch('auth/logout');

        // 로컬 스토리지에 저장된 아이디 가져오기
        this.username = window.localStorage.getItem('careId');

        if (this.username === '' || this.username === null) {
            this.isSaveId = false;
        } else {
            this.isSaveId = true;
        }
    },
    methods: {
        async signup() {
            const { username, password, cid } = this;

            if (!username || !password) {
                alert('로그인 정보를 입력하세요.');
                return false;
            }

            const type = 'S';       // 센터직원:D, 케어관리자:S

            await this.$store
                .dispatch('auth/login', { username, password, type, cid })
                .then(() => {
                    this.$router.push({
                        name: 'businessCenterList',
                    });
                })
                .catch(({ message }) => {
                    alert(message);
                });

            // 아이디를 로컬 스토리지에 저장하는 부분
            if (this.isSaveId) {
                window.localStorage.setItem('careId', this.username);
            } else {
                window.localStorage.removeItem('careId');
            }
        },
    },
};
</script>
<style lang='scss'>
</style>
